<template>
  <div>
    <v-navigation-drawer v-if="isAuthenticated" v-model="drawer" :mini-variant.sync="mini" fixed clipped
      :permanent="filter" app>
      <v-list dense v-if="!filter">
        <v-list-item dense>
          <v-list-item-icon class="listTitleHover" v-if="mini" @click.stop="mini = !mini">
            <v-icon>mdi-chevron-right</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="listTitleHover" v-if="!mini" @click="mini = !mini">Свернуть</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon class="listTitleHover" v-if="!mini" @click.stop="mini = !mini">
            <v-icon>mdi-chevron-left</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-divider></v-divider>
        <template v-for="item in menuItems">
          <template v-if="!item.items">
            <v-list-item link :to="item.url" :key="item.id" v-if="!checkUrl(item.url)">
              <v-list-item-icon class="main__menu__item">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-else>
            <v-list-group :prepend-icon="item.icon" value="true" :key="item.icon">
              <template v-slot:activator>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </template>
              <template v-for="SubItem in item.items">
                <v-list-item link :to="SubItem.url" :key="SubItem.title">
                  <v-list-item-icon>
                    <v-icon>{{ SubItem.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="SubItem.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </template>
        <!-- <template v-else> -->
        <!-- <v-list-item
              link
              v-for="(item, i) in items2"
              :key="i"
              :to="item.url"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
        <!-- </template> -->
      </v-list>
      <template v-else>
        <CalcResultFilter />
      </template>
    </v-navigation-drawer>

    <v-app-bar dense clipped-left app v-if="checkAuthAndGetInfo">
      <div style="
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
        <div class="onHover onHoverColor profile" @click="showProfile = !showProfile">
          <v-icon>fa fa-user-circle</v-icon>
          {{
            profile && profile.emailContact
            ? profile.emailContact
            : profile.name
              ? profile.name
              : ""
          }}
          ( {{ getRoleName(role()) }} )
          <!-- Сессия:{{ session()}} -->
        </div>
        <AddOrEditUser :show="showProfile" v-model="profile" title="Просмотр учетной записи" :readonly="true"
          @close="showProfile = false" v-if="showProfile" />
        <!-- <EditUser
          v-model="showProfile"
          :editedItem="profile"

          :edit="false"
          @close="showProfile = false"
        /> -->
        <div style="display: inline-flex; align-items: center" v-if="checkRole(roleObj.manager)">
          <CalcCount v-if="isAuthenticated && myOrganisation.inn !== '505203230884'" />
          <h3 v-if="!checkRole(roleObj.manager) &&
            myOrganisation.inn !== '505203230884'
            ">
            {{ myOrganisation.orgShortName }}
          </h3>
          <router-link tag="h3" class="link" to="/myorganisation" v-if="checkRole(roleObj.manager)">
            {{ myOrganisation.orgShortName }}</router-link>
          <!-- <v-btn
        tile
        link
        to="/myorganisation"
        class="top_menu"

      >
        <v-icon left class="material-icons"> business </v-icon>
        Моя организация
      </v-btn> -->
        </div>
      </div>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <CalcFilterMessageBox v-if="isAuthenticated" />
    <!-- <v-footer app></v-footer> -->
    <v-footer v-if="loginOrRegister">
      <v-col class="text-center" cols="12">
        <p>
          Есть вопросы? Пишите в техподдержку
          <a href="mailto:help@vmmm.ru" target="_blank">help@vmmm.ru</a>
        </p>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
import CalcCount from "../components/CalcCount.vue";
import roles, { roleObj } from "../plugins/roles.js";
import AddOrEditUser from "./AddOrEditUser.vue";
import CalcResultFilter from "./CalcResultFilter.vue";
import CalcFilterMessageBox from "@/components/CalcFilterMessageBox.vue";

export default {
  components: {
    CalcCount,
    AddOrEditUser,
    CalcResultFilter,
    CalcFilterMessageBox,
  },
  data: () => ({
    drawer: true,
    mini: false,
    iconDrawer: "chevron_left",
    roleObj,
    roles,
    // selectedRole: "",
    items2: [
      {
        title: "Вход",
        icon: "fas fa-sign-in-alt",
        url: "/login",
      },
      {
        title: "Регистрация",
        icon: "person_add",
        url: "/register",
      },
    ],
    showProfile: false,
    profile: {},
  }),
  methods: {
    checkUrl(url) {
      // 505203230884 //telegram inn
      // 6324003370 //ET inn
      return this.myOrganisation.inn == "505203230884" && url === "/payment";
    },
    // selectRole(evt) {
    //   const profile = JSON.parse(localStorage.getItem("profile"));
    //   profile.role = roles.filter((item) => item.role === evt)[0].name;
    //   this.$store.dispatch(
    //     "set_profile_role",
    //     roles.filter((item) => item.role === evt)[0].name
    //   );
    //   localStorage.setItem("profile", JSON.stringify(profile));
    //   location.reload();
    // },
    getProfile() {
      const profile = JSON.parse(localStorage.getItem("profile"));
      if (profile) {
        this.profile = profile;
        this.profile.profile_name = this.profile.name;
      }
    },
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters.filter;
      },
      set(val) {
        this.$store.dispatch("setFilter", val);
      },
    },
    checkAuthAndGetInfo() {
      if (this.isAuthenticated) {
        this.myOrganisation.inn === null &&
          this.myOrganisation.orgShortName === null &&
          this.$store.dispatch("MyOrgInfoShort");
        return true;
      }
      return false;
    },
    menuItems() {
      return this.$store.getters.getMenuItems;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    myOrganisation() {
      return this.$store.getters.getMyOrganisation;
    },
    loginOrRegister() {
      if (this.$route.path === "/register" || this.$route.path === "/login") {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getProfile();
    // this.selectedRole = roles.filter(
    //   (item) => item.name === this.$store.getters.role
    // )[0].role;
    //get MyOrganisation info
    // if (this.url) {
    //   this.$router.push(this.url);
    // }
  },
  watch: {
    filter(val) {
      if (val) {
        this.mini = false;
      }
    },
  },
};
</script>

<style lang="scss">
.v-footer {
  position: fixed !important;
  width: 100%;
  bottom: 0 !important;
}

.listTitleHover {
  cursor: pointer;
}

.top_menu.v-btn--active.v-btn.v-btn--contained.v-btn--router.v-btn--tile.theme--light.v-size--default {
  background-color: #217899;
  color: white;
}

.main__menu__item {
  width: 24px;
  height: 24px;
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
}

.link {
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.profile {
  padding: 5px 10px;
}
</style>
